import { REQUEST, SUCCESS, FAILURE } from '../../actions/constants'
import { actionCreator, createRequestTypes, createApiActions } from '../../actions'


export const LOAD_SB_POST = 'LOAD_SB_POST'
export const loadSBPost = ({ storyId }) => actionCreator(LOAD_SB_POST, { storyId })

export const LOAD_SB_POST_DATA = createRequestTypes('LOAD_SB_POST_DATA')
export const getSBPostAction = createApiActions(LOAD_SB_POST_DATA)


export const LOAD_SB_CATEGORY = 'LOAD_SB_CATEGORY'
export const loadSBCategory = ({ storyId }) => actionCreator(LOAD_SB_CATEGORY, { storyId })

export const LOAD_SB_CATEGORY_DATA = createRequestTypes('LOAD_SB_CATEGORY_DATA')
export const getSBCategoryAction = createApiActions(LOAD_SB_CATEGORY_DATA)


export const RESET_SB_CATEGORY_DATA = 'RESET_SB_CATEGORY_DATA'
export const resetSBCategoryData = () => actionCreator(RESET_SB_CATEGORY_DATA)


export const LOAD_SB_AUTHOR = 'LOAD_SB_AUTHOR'
export const loadSBAuthor = ({ storyId }) => actionCreator(LOAD_SB_AUTHOR, { storyId })

export const LOAD_SB_AUTHOR_DATA = createRequestTypes('LOAD_SB_AUTHOR_DATA')
export const getSBAuthorAction = createApiActions(LOAD_SB_AUTHOR_DATA)


export const RESET_SB_AUTHOR_DATA = 'RESET_SB_AUTHOR_DATA'
export const resetSBAuthorData = () => actionCreator(RESET_SB_AUTHOR_DATA)


export const LOAD_SB_FEATURED_DATA = createRequestTypes('LOAD_SB_FEATURED_DATA')
export const getSBFeaturedAction = createApiActions(LOAD_SB_FEATURED_DATA)


export const LOAD_SB_CATEGORIES_DATA = createRequestTypes('LOAD_SB_CATEGORIES_DATA')
export const getSBCategoriesAction = createApiActions(LOAD_SB_CATEGORIES_DATA)


export const LOAD_SB_POST_LIST_BY_CAT = 'LOAD_SB_POST_LIST_BY_CAT'
export const loadSBPostListByCat = ({ uuid, pageNum }) =>
  actionCreator(LOAD_SB_POST_LIST_BY_CAT, { categoryUuid: uuid, pageNum })

export const LOAD_SB_POST_LIST_BY_AUTHOR = 'LOAD_SB_POST_LIST_BY_AUTHOR'
export const loadSBPostListByAuthor = ({ uuid, pageNum }) =>
  actionCreator(LOAD_SB_POST_LIST_BY_AUTHOR, { authorUuid: uuid, pageNum })

export const LOAD_SB_POST_LIST_BY_GROUP_DATA = createRequestTypes('LOAD_SB_POST_LIST_BY_GROUP_DATA')
export const getSBPostListByGroupAction = createApiActions(LOAD_SB_POST_LIST_BY_GROUP_DATA)


export const LOAD_SB_RELATED_POSTS = 'LOAD_SB_RELATED_POSTS'
export const loadSBRelatedPosts = (categories) => actionCreator(LOAD_SB_RELATED_POSTS, { categories })

export const LOAD_SB_RELATED_POSTS_DATA = createRequestTypes('LOAD_SB_RELATED_POSTS_DATA')
export const getSBRelatedPostsAction = createApiActions(LOAD_SB_RELATED_POSTS_DATA)

// BLOG HOME PAGE ACTIONS
export const LOAD_SB_HOME = 'LOAD_SB_HOME'
export const loadSBHome = () => actionCreator(LOAD_SB_HOME)

export const LOAD_SB_BLOG_HOME_DATA = createRequestTypes('LOAD_SB_BLOG_HOME_DATA')
export const getSBBlogHomeAction = createApiActions(LOAD_SB_BLOG_HOME_DATA)

// export const LOAD_SB_MOST_POPULAR_POSTS_DATA = createRequestTypes('LOAD_SB_MOST_POPULAR_POSTS_DATA')
// export const getSBMostPopularPostsAction = createApiActions(LOAD_SB_MOST_POPULAR_POSTS_DATA)


export const LOAD_SB_LATEST_POSTS_DATA = createRequestTypes('LOAD_SB_LATEST_POSTS_DATA')
export const getSBLatestPostsAction = {
  request: ({ page }) => actionCreator(LOAD_SB_LATEST_POSTS_DATA[REQUEST], { page }),
  success: (defaults, response) => actionCreator(LOAD_SB_LATEST_POSTS_DATA[SUCCESS], { response }),
  failure: (defaults, error) => actionCreator(LOAD_SB_LATEST_POSTS_DATA[FAILURE], { error }),
}

export const RELOAD_SB_LATEST_POSTS = 'RELOAD_SB_LATEST_POSTS'
export const loadSBLatestPosts = ({ page }) => actionCreator(RELOAD_SB_LATEST_POSTS, { page })


// export const POPULAR_POST_IDS_API = createRequestTypes('POPULAR_POST_IDS_API')
// export const getPopularPostIds = createApiActions(POPULAR_POST_IDS_API)
